export function AutoQueryGenerator(texFile, ace, props, setTexFile) {
    if (texFile) {
        // 1️⃣ Collect all referenced figure labels
        const refRegex = /\\ref\{(fig[^}]*)\}/g;
        const refSet = new Set();
        let match;

        while ((match = refRegex.exec(texFile)) !== null) {
            refSet.add(match[1]);
        }

        // 2️⃣ Regex to match uncommented figure blocks
        const figureRegex =
            /^(?!\s*%)\\begin\{figure\}[\s\S]*?^(?!\s*%)\\end\{figure\}/gmi;

        const labelRegex = /(?!\s*%)\\label\{(fig[^}]*)\}/;

        // 3️⃣ Track where \AQ{} needs to be inserted
        const insertPositions = [];

        while ((match = figureRegex.exec(texFile)) !== null) {
            const figureBlock = match[0];
            const figureStartIndex = match.index;

            const labelMatch = figureBlock.match(labelRegex);
            if (!labelMatch) continue;

            const label = labelMatch[1];

            // If this figure label is NOT referenced anywhere
            if (!refSet.has(label)) {
                // Start of the line where \begin{figure} occurs
                const beginLineStart =
                    texFile.lastIndexOf("\n", figureStartIndex) + 1;

                // Previous line start
                const prevLineStart =
                    texFile.lastIndexOf("\n", beginLineStart - 2) + 1;

                const prevLine = texFile
                    .slice(prevLineStart, beginLineStart)
                    .trim();

                // Avoid adding duplicate \AQ{}
                if (!prevLine.startsWith("\\AQ{")) {
                    insertPositions.push(beginLineStart);
                }
            }
        }

        // 4️⃣ Build updated document (reverse insertion to avoid index shift)
        let updatedTexFile = texFile;

        for (let i = insertPositions.length - 1; i >= 0; i--) {
            const pos = insertPositions[i];
            updatedTexFile =
                updatedTexFile.slice(0, pos) +
                "\\AQ{figure Reference missing}\n" +
                updatedTexFile.slice(pos);
        }

        // 5️⃣ Update React state (or use updatedTexFile further)
        setTexFile(updatedTexFile);
    }


    // const editor = ace.current.editor;
    // const session = editor.getSession();
    // const doc = session.getDocument();

    // let anchor;
    // if (!anchor) {

    //   anchor = doc.createAnchor(4, 5);
    // }
    // console.log("Anchor the doc is created :", anchor)
    // anchor.insertRight = true;


    // anchor.on("change", function (delta) {
    //   const pos = anchor.getPosition();
    //   console.log("Anchor moved to:", pos.row, pos.column);
    // });

    // console.log("Anchor created at:", anchor.getPosition());


}
